import { Loader2 } from 'lucide-react';
import { cn } from '../lib/cn';

export type SpinnerProps = {
  className?: string;
  label?: string;
};

export function Spinner({ className, label = 'Đang tải' }: SpinnerProps) {
  return (
    <span role="status" aria-label={label} className={cn('inline-flex', className)}>
      <Loader2 className="h-4 w-4 animate-spin" />
      <span className="sr-only">{label}</span>
    </span>
  );
}
